import axios from "axios";
import Cookies from "js-cookie";
let url =  process.env.REACT_APP_URL_API || "https://planb.maxitask.com/maxioperationapi/api/";

const token = Cookies.get(`OperationToken`);
export default axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json",
    TokenUser: token,
  },
});
